import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNotifications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.335 4.727v.526c-2.69 1.103-4.57 4.726-4.5 7.866v1.744c-1.378 1.77-1.297 4.41 2.138 4.41h2.362c0 .723.282 1.417.784 1.928A2.65 2.65 0 0 0 12.01 22c.71 0 1.39-.287 1.892-.799a2.754 2.754 0 0 0 .784-1.928h2.368c3.429 0 3.478-2.645 2.102-4.415l.038-1.736c.07-3.144-1.814-6.77-4.508-7.872v-.523c0-.723-.282-1.417-.784-1.928A2.65 2.65 0 0 0 12.01 2c-.71 0-1.39.287-1.891.799a2.754 2.754 0 0 0-.784 1.928Zm3.567 0-.001.055a7.123 7.123 0 0 0-1.78.001.918.918 0 0 1 .26-.699.883.883 0 0 1 1.26 0c.167.17.261.402.261.643ZM11.12 19.273c0 .24.094.472.26.643a.884.884 0 0 0 1.262 0 .918.918 0 0 0 .261-.643H11.12Zm5.935-1.819c.762 0 1.173-.91.677-1.5a1.54 1.54 0 0 1-.361-1.025l.04-1.848c.069-3.087-2.367-6.536-5.396-6.536-3.028 0-5.464 3.448-5.397 6.534l.04 1.85a1.54 1.54 0 0 1-.36 1.025c-.496.59-.085 1.5.676 1.5h10.08Z"
      fill="#000"
    />
  </svg>
);
const Memo = memo(SvgNotifications);
export default Memo;
